import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app" }
const _hoisted_2 = { class: "inputContainer" }

import CharacterDisplay from "./components/CharacterDisplay.vue";
import { ref, computed } from "vue";
import SettingsVue from "./components/Settings.vue";
import InfoVue from "./components/Info.vue";
import CorrectableInput from "./components/CorrectableInput.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const settings = ref(
  null as null | {
    shownLength: number;
    emptyLength: number;
    sequenceLength: number;
    digitDistance: number;
  }
);

const input1 = ref(null as null | typeof CorrectableInput);
const input2 = ref(null as null | typeof CorrectableInput);

const input1Digit = ref(null as null | number);
const input2Digit = ref(null as null | number);

const currentDigits = ref(null as null | [number, number]);

const finishedTest = computed(() => {
  return (
    input1Digit.value !== null &&
    input2Digit.value !== null &&
    currentDigits.value !== null
  );
});

function handleStart(digits: [number, number]) {
  if (input1.value === null || input2.value === null) return;
  input1.value.clear();
  input2.value.clear();
  input1.value.focus();

  currentDigits.value = digits;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SettingsVue, {
      class: "settings",
      onUpdate: _cache[0] || (_cache[0] = (v) => (settings.value = v))
    }),
    _createVNode(InfoVue, { class: "info" }),
    (settings.value !== null)
      ? (_openBlock(), _createBlock(CharacterDisplay, {
          key: 0,
          onStart: handleStart,
          "empty-length": settings.value.emptyLength,
          "shown-length": settings.value.shownLength,
          "sequence-length": settings.value.sequenceLength,
          "digit-distance": settings.value.digitDistance
        }, null, 8, ["empty-length", "shown-length", "sequence-length", "digit-distance"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(CorrectableInput, {
        ref_key: "input1",
        ref: input1,
        show: _unref(finishedTest),
        should: currentDigits.value === null ? undefined : currentDigits.value[0],
        onUpdate: _cache[1] || (_cache[1] = 
          (v) => {
            input1Digit.value = v;
            input2.value?.focus();
          }
        ),
        onTab: _cache[2] || (_cache[2] = ($event: any) => (input2.value?.focus()))
      }, null, 8, ["show", "should"]),
      _createVNode(CorrectableInput, {
        ref_key: "input2",
        ref: input2,
        show: _unref(finishedTest),
        should: currentDigits.value === null ? undefined : currentDigits.value[1],
        onUpdate: _cache[3] || (_cache[3] = 
          (v) => {
            input2Digit.value = v;
            input1.value?.focus();
          }
        ),
        onTab: _cache[4] || (_cache[4] = ($event: any) => (input1.value?.focus()))
      }, null, 8, ["show", "should"])
    ])
  ]))
}
}

})